import client from './client';

export const getNosotrosPageData = async () => {
    try {
        const query = [
            'populate[hero][populate]=*',
            'populate[sections][populate]=*',
            'populate[faqs][populate]=*',
            'populate[glossary][populate]=*',
            'populate[alliances][populate]=*'
        ].join('&');

        const response = await client.get(`/api/nosotros-page?${query}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching Nosotros page data:', error);
        return null;
    }
};
